(function () {
  const section = document.currentScript.parentElement;
  const initHeadingAnimation = (sectionEl) => {
    if (
      !sectionEl ||
      !sectionEl?.classList.contains("image-with-text-section")
    ) {
      return;
    }
    const enableAnimation = sectionEl.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("anim-active");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(sectionEl);
  };
  const initParallax = (sectionEl) => {
    if (!sectionEl) return;
    const parallaxItem = sectionEl.querySelector(".js-parallax");
    if (!parallaxItem) return;
    const propertyValue = parseInt(parallaxItem.dataset.parallaxPropertyValue);
    const parallaxSteps = parallaxItem.dataset.parallaxSteps;
    let stepStart, stepEnd;
    if (parallaxSteps) {
      [stepStart, stepEnd] = parallaxSteps.split(", ").map(Number);
    }
    let isVisible = false;
    const scrollAnimate = () => {
      if (!isVisible) return;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const rect = parallaxItem.getBoundingClientRect();
      const elementTop = rect.top + scrollY;
      const elementHeight = rect.height;
      const elementStart = elementTop - windowHeight;
      const elementEnd = elementTop + elementHeight;
      const scrollPosition = Math.max(0, scrollY - elementStart);
      const maxScroll = elementEnd - elementStart;
      let scrollPercent = (scrollPosition / maxScroll) * 100;
      scrollPercent = Math.max(0, Math.min(100, scrollPercent));
      let calculatedValue = 0;
      if (parallaxSteps) {
        if (scrollPercent >= stepStart && scrollPercent <= stepEnd) {
          const stepRange = stepEnd - stepStart;
          const stepProgress = (scrollPercent - stepStart) / stepRange;
          calculatedValue = propertyValue * stepProgress;
        } else if (scrollPercent > stepEnd) {
          calculatedValue = propertyValue;
        }
      } else {
        calculatedValue = (propertyValue * scrollPercent) / 100;
      }
      parallaxItem.style.transform = `translate3d(0, ${calculatedValue}px, 0)`;
    };
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          scrollAnimate();
          ticking = false;
        });
        ticking = true;
      }
    };
    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;
          if (isVisible) scrollAnimate();
        });
      },
      { rootMargin: "100px 0px" }
    );
    visibilityObserver.observe(parallaxItem);
    let resizeTimer;
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scrollAnimate, 100);
    });
  };
  initHeadingAnimation(section);
  initParallax(section);
  document.addEventListener("shopify:section:load", function (event) {
    initHeadingAnimation(event.target);
    initParallax(event.target);
  });
})();
